import { z } from 'zod';
import { PapelMembro } from './enums.js';
import { Id } from './comum.js';
import { Senha } from './auth.js';

export const Departamento = z.object({
  id: Id,
  nome: z.string(),
  sigla: z.string(),
  cor: z.string().nullable(),
  ordem: z.number().int(),
  ativo: z.boolean(),
  /** envio ao cliente só deste departamento: para onde o cliente responde e a assinatura do rodapé */
  emailResposta: z.string().nullable().optional(),
  assinaturaEmail: z.string().nullable().optional(),
});
export type Departamento = z.infer<typeof Departamento>;

export const DepartamentoBody = z.object({
  nome: z.string().trim().min(2).max(60),
  sigla: z.string().trim().min(1).max(8).toUpperCase(),
  cor: z.string().regex(/^#[0-9a-fA-F]{6}$/).nullable().optional(),
  ordem: z.number().int().min(0).default(0),
  ativo: z.boolean().default(true),
  emailResposta: z.email().max(200).nullable().optional(),
  assinaturaEmail: z.string().trim().max(1000).nullable().optional(),
});
export type DepartamentoBody = z.infer<typeof DepartamentoBody>;

export const AcessoClientes = z.enum(['TODOS', 'CARTEIRA']);
export type AcessoClientes = z.infer<typeof AcessoClientes>;

export const Membro = z.object({
  id: Id,
  usuarioId: Id,
  nome: z.string(),
  email: z.string(),
  papel: PapelMembro,
  departamentoId: Id.nullable(),
  ativo: z.boolean(),
  apelido: z.string().nullable(),
  /** TODOS os clientes ou só a CARTEIRA (liberados + onde é responsável). Só tem efeito para operador e leitor. */
  acessoClientes: AcessoClientes.default('TODOS'),
  /** clientes liberados à mão na carteira */
  clientesNaCarteira: z.number().int().default(0),
  /** nos envios que fizer sozinha, o cliente responde para o e-mail desta pessoa */
  responderPeloEmail: z.boolean().optional(),
});
export type Membro = z.infer<typeof Membro>;

export const CarteiraCliente = z.object({ id: Id, nome: z.string(), documento: z.string(), /** MANUAL = liberado na carteira; RESPONSAVEL = entra sozinho por ser responsável de um departamento */ origem: z.enum(['MANUAL', 'RESPONSAVEL']) });
export const Carteira = z.object({ membroId: Id, acessoClientes: AcessoClientes, /** papel que sempre vê tudo (administrador, supervisor) */ sempreTodos: z.boolean(), clientes: z.array(CarteiraCliente) });
export type Carteira = z.infer<typeof Carteira>;
export const CarteiraBody = z.object({ acessoClientes: AcessoClientes, /** lista completa dos liberados à mão (substitui a anterior) */ clienteIds: z.array(Id).max(5000) });
export type CarteiraBody = z.infer<typeof CarteiraBody>;

export const MembroBody = z.object({
  nome: z.string().trim().min(2).max(120),
  email: z.email().max(200),
  papel: PapelMembro,
  departamentoId: Id.nullable().optional(),
  apelido: z.string().trim().max(10).nullable().optional(),
  ativo: z.boolean().default(true),
  responderPeloEmail: z.boolean().optional(),
  /** senha inicial; se ausente, o usuário recebe convite (fase F6) */
  senha: Senha.optional(),
});
export type MembroBody = z.infer<typeof MembroBody>;
